import { useEffect, useRef, useState } from "react";
import "../CSS/slideshow.css"
import TestimonialsJSON from "./Testimonials.json";
const delay = 2500;


function TestimonialCards() {
    const [index, setIndex] = useState(0);
    const timeoutRef = useRef(null);

    function resetTimeout() {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }

    useEffect(() => {
        resetTimeout();
        timeoutRef.current = setTimeout(
            () =>
                setIndex((prevIndex) =>
                    prevIndex === TestimonialsJSON.length - 1 ? 0 : prevIndex + 1
                ),
            delay
        );

        return () => {
            resetTimeout();
        };
    }, [index]);

    return (
        <div style={{marginBottom: "30px" , minHeight: "500px"}}>
            <h3 className="partner-heading">Testimonials</h3>
            <div className="slideshow slideshow-testimonial">
                <div
                    className="slideshowSlider"
                    style={{ transform: `translate3d(${-index * 100}%, 0, 0)` }}
                >
                    {TestimonialsJSON.map((obj, index) => (
                        <div className="container testimonials">
                            <blockquote className="content-testimonials">
                                <span>
                                    "{obj.content}"
                                </span>
                            </blockquote>
                            <p className="name-testimonials">{obj.name}</p>
                            <p className="name-testimonials">{obj.org}</p>
                            <div></div>
                            {/* <p ><b>{obj.content}</b></p> */}
                        </div>
                    ))}
                    {/* <div>Hello</div> */}
                </div>

                <div className="slideshowDots">
                    {TestimonialsJSON.map((_, idx) => (
                        <div
                            key={idx}
                            className={`slideshowDot${index === idx ? " active" : ""}`}
                            onClick={() => {
                                setIndex(idx);
                            }}
                        ></div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default TestimonialCards;

// ReactDOM.render(<Slideshow />, document.getElementById("App"));
